const { addAction } = window.sitchco.hooks;

/**
 * Roundabout content slider overrides: the right-side peek that shows the track
 * continues past the edge of the screen.
 *
 * The peek is driven by Splide's `overflow` event rather than by comparing the
 * slide count to `perPage`. That comparison never reported a fit — it reported an
 * assumption — and it stops meaning anything at all under fixed-width sizing,
 * where `perPage` no longer describes how many slides are visible. `overflow` is
 * measured, and Splide re-measures it on resize, load, and breakpoint change.
 *
 * Padding is applied only *after* the first measurement, never seeded into the
 * config: Splide measures overflow against the padded track, so a peek present at
 * mount would be part of the evidence for whether there is anything to peek at.
 * Measuring unpadded first also makes the toggle stable in both directions —
 * adding a peek to an overflowing slider keeps it overflowing, and removing one
 * from a slider that fits keeps it fitting.
 */

// A percentage peek is a share of the track, so under `perPage` it scaled with the
// slide. A fixed-width slide has no such relationship: the same 15% would uncover a
// different fraction of the card at every screen size. Bounded absolute values keep
// the sliver reading as the same affordance at any width.
const PEEK_BY_COUNT = {
    left: 0,
    right: '15%',
};
const PEEK_BY_WIDTH = {
    left: 0,
    right: 'clamp(1.5rem, 6%, 4.5rem)',
};

addAction('content-slider.init', (splide, element) => {
    const peek = element.classList.contains('is-sizing-fixed-width') ? PEEK_BY_WIDTH : PEEK_BY_COUNT;

    splide.on('overflow', (isOverflow) => {
        splide.options = { padding: isOverflow ? peek : 0 };
    });
});
